import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Container, Typography, Button, Box, Grid, Card, Avatar, useTheme } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PeopleIcon from '@mui/icons-material/People';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { useState, useEffect } from 'react';

const Home = () => {
  const { user, logout } = useAuth();
  const theme = useTheme();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const weddingImages = [
    "https://seethakalyanavaibhogame.com/images/banner01.jpg",
    "https://seethakalyanavaibhogame.com/images/banner03.png",
    "https://seethakalyanavaibhogame.com/images/banner02.jpg",
    "https://seethakalyanavaibhogame.com/images/banner04.png",
    "https://seethakalyanavaibhogame.com/images/banner05.png",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === weddingImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [weddingImages.length]);

  return (
    <Box sx={{ bgcolor: theme.palette.background.default }}>
      {/* Hero Section with Image Carousel */}
      <Box sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(62,2,23,0.3) 0%, rgba(125,31,79,0.2) 100%)',
          zIndex: 2
        }
      }}>
        {/* Image Carousel */}
        {weddingImages.map((image, index) => (
          <Box
            key={index}
            component="img"
            src={image}
            alt={`Wedding ${index + 1}`}
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: index === currentImageIndex ? 1 : 0,
              transition: 'opacity 1s ease-in-out',
              zIndex: 1
            }}
          />
        ))}
        
        {/* Image Indicators */}
        <Box sx={{
          position: 'absolute',
          bottom: 40,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 2,
          zIndex: 3
        }}>
          {weddingImages.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: index === currentImageIndex ? theme.palette.primary.main : 'rgba(255,255,255,0.5)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: theme.palette.primary.light
                }
              }}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </Box>

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 3 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={7}>
              <Box sx={{ mb: 2 }}>
                <Typography 
                  variant="overline" 
                  sx={{ 
                    color: 'white',
                    fontWeight: 600,
                    letterSpacing: 2,
                    mb: 2,
                    display: 'block'
                  }}
                >
                  ✨ Trusted by Millions Worldwide
                </Typography>
              </Box>
              <Typography 
                variant="h1" 
                sx={{ 
                  color: '#2c1810',
                  fontWeight: 900,
                  fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
                  mb: 3,
                  lineHeight: 1.1,
                  textShadow: '0 2px 4px rgba(255,255,255,0.8)'
                }}
              >
                Find Your Perfect
                <Box component="span" sx={{ 
                  display: 'block',
                  background: 'linear-gradient(45deg, #2c1810, #5d4037)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  Soulmate Today
                </Box>
              </Typography>
              <Typography 
                variant="h5" 
                sx={{ 
                  color: 'white',
                  mb: 4,
                  fontWeight: 500,
                  maxWidth: '600px',
                  lineHeight: 1.6,
                  fontSize: { xs: '1.1rem', md: '1.3rem' },
                  textShadow: '0 1px 2px rgba(255,255,255,0.6)'
                }}
              >
                Join millions of happy couples who discovered true love through our advanced matching algorithm. 
                Your journey to forever starts here.
              </Typography>
              {/* {!user && (
                <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                  <Button
                    component={Link}
                    to="/register"
                    variant="contained"
                    size="large"
                    startIcon={<FavoriteIcon />}
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: 'white',
                      px: 5,
                      py: 2,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      borderRadius: '50px',
                      boxShadow: '0 8px 25px rgba(62,2,23,0.3)',
                      '&:hover': { 
                        bgcolor: theme.palette.primary.dark,
                        transform: 'translateY(-3px)',
                        boxShadow: '0 12px 35px rgba(62,2,23,0.4)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Start Your Journey
                  </Button>
                  <Button
                    component={Link}
                    to="/login"
                    variant="outlined"
                    size="large"
                    sx={{
                      borderColor: 'white',
                      borderWidth: 2,
                      color: 'white',
                      px: 5,
                      py: 2,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      borderRadius: '50px',
                      '&:hover': { 
                        borderColor: 'white',
                        borderWidth: 2,
                        bgcolor: 'rgba(255,255,255,0.1)',
                        transform: 'translateY(-3px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Sign In
                  </Button>
                </Box>
              )}
              {user && (
                <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                  <Button
                    component={Link}
                    to="/dashboard"
                    variant="contained"
                    size="large"
                    startIcon={<PeopleIcon />}
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: 'white',
                      px: 5,
                      py: 2,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      borderRadius: '50px',
                      boxShadow: '0 8px 25px rgba(62,2,23,0.3)',
                      '&:hover': { 
                        bgcolor: theme.palette.primary.dark,
                        transform: 'translateY(-3px)',
                        boxShadow: '0 12px 35px rgba(62,2,23,0.4)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Go to Dashboard
                  </Button>
                  <Button
                    onClick={() => logout()}
                    variant="outlined"
                    size="large"
                    sx={{
                      borderColor: 'white',
                      borderWidth: 2,
                      color: 'white',
                      px: 5,
                      py: 2,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      borderRadius: '50px',
                      '&:hover': { 
                        borderColor: 'white',
                        borderWidth: 2,
                        bgcolor: 'rgba(255,255,255,0.1)',
                        transform: 'translateY(-3px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Logout
                  </Button>
                </Box>
              )} */}
            </Grid>
            <Grid item xs={12} md={5}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>
                <Box sx={{
                  width: { xs: '300px', md: '400px' },
                  height: { xs: '300px', md: '400px' },
                  borderRadius: '50%',
                  background: 'linear-gradient(45deg, rgba(62,2,23,0.1), rgba(125,31,79,0.05))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  border: '3px solid rgba(255,255,255,0.2)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '80%',
                    height: '80%',
                    borderRadius: '50%',
                    background: 'linear-gradient(45deg, rgba(62,2,23,0.15), rgba(125,31,79,0.08))',
                    animation: 'pulse 2s infinite'
                  }
                }}>
                  <FavoriteIcon sx={{ 
                    fontSize: { xs: '120px', md: '150px' },
                    color: 'white',
                    zIndex: 2,
                    animation: 'float 3s ease-in-out infinite'
                  }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Statistics Section */}
      <Box sx={{ 
        py: 10,
        bgcolor: theme.palette.background.paper,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '100px',
          background: 'linear-gradient(to bottom right, transparent 49%, #ffffff 50%)',
          transform: 'translateY(-100%)'
        }
      }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            sx={{ 
              textAlign: 'center',
              mb: 6,
              fontWeight: 700,
              color: theme.palette.primary.main,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Trusted by Millions
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {stats.map((stat, index) => (
              <Grid item xs={6} md={3} key={index}>
                <Box sx={{ 
                  textAlign: 'center',
                  p: 3,
                  transition: 'all 0.3s ease',
                  borderRadius: '20px',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    bgcolor: 'rgba(62,2,23,0.05)'
                  }
                }}>
                  <Typography 
                    variant="h2" 
                    sx={{ 
                      color: theme.palette.primary.main,
                      fontWeight: 900,
                      mb: 1,
                      fontSize: { xs: '2.5rem', md: '3rem' }
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: theme.palette.text.secondary,
                      fontWeight: 600,
                      fontSize: { xs: '0.9rem', md: '1rem' }
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Box sx={{ py: 15, bgcolor: theme.palette.background.default }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4 } }}>
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: theme.palette.primary.main,
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
                display: 'block'
              }}
            >
              Why Choose Us
            </Typography>
            <Typography 
              variant="h2" 
              sx={{ 
                fontWeight: 800,
                color: theme.palette.primary.main,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                mb: 3
              }}
            >
              The Perfect Platform for
              <Box component="span" sx={{ 
                display: 'block',
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                True Love
              </Box>
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: theme.palette.text.secondary,
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Our advanced features and commitment to your success make us the preferred choice for finding meaningful relationships.
            </Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            gap: 4,
            overflowX: { xs: 'auto', md: 'visible' },
            pb: { xs: 2, md: 0 },
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme.palette.primary.main,
              borderRadius: '4px',
            },
          }}>
            {features.map((feature, index) => (
              <Card 
                key={index}
                sx={{ 
                  p: 5,
                  minWidth: { xs: '300px', md: 'auto' },
                  flex: { md: 1 },
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  transition: 'all 0.4s ease',
                  borderRadius: '24px',
                  background: theme.palette.background.paper,
                  border: `1px solid rgba(62,2,23,0.1)`,
                  '&:hover': {
                    transform: 'translateY(-15px)',
                    boxShadow: '0 20px 40px rgba(62,2,23,0.15)',
                    border: `1px solid rgba(62,2,23,0.2)`
                  }
                }}
              >
                <Box sx={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  bgcolor: theme.palette.background.default,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 4,
                  border: `3px solid rgba(62,2,23,0.1)`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    border: `3px solid rgba(62,2,23,0.3)`,
                    transform: 'scale(1.1)'
                  }
                }}>
                  {feature.icon}
                </Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    mb: 3,
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    fontSize: { xs: '1.3rem', md: '1.5rem' }
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.8,
                    fontSize: '1.1rem'
                  }}
                >
                  {feature.description}
                </Typography>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* How It Works Section */}
      <Box sx={{ py: 15, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4 } }}>
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: theme.palette.primary.main,
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
                display: 'block'
              }}
            >
              Simple Steps
            </Typography>
            <Typography 
              variant="h2" 
              sx={{ 
                fontWeight: 800,
                color: theme.palette.primary.main,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                mb: 3
              }}
            >
              How It Works
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: theme.palette.text.secondary,
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Finding your perfect match is easier than ever with our streamlined process designed for your success.
            </Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            gap: 4,
            overflowX: { xs: 'auto', md: 'visible' },
            pb: { xs: 2, md: 0 },
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme.palette.primary.main,
              borderRadius: '4px',
            },
          }}>
            {steps.map((step, index) => (
              <Box 
                key={index}
                sx={{ 
                  position: 'relative',
                  p: 5,
                  minWidth: { xs: '300px', md: 'auto' },
                  flex: { md: 1 },
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  '&::after': index < steps.length - 1 ? {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    right: '-32px',
                    width: '64px',
                    height: '3px',
                    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                    transform: 'translateY(-50%)',
                    borderRadius: '2px',
                    '@media (max-width: 900px)': {
                      display: 'none'
                    }
                  } : {}
                }}
              >
                <Box sx={{ 
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 4,
                  position: 'relative',
                  boxShadow: '0 10px 30px rgba(62,2,23,0.3)',
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: '0 15px 40px rgba(62,2,23,0.4)'
                  },
                  transition: 'all 0.3s ease'
                }}>
                  <Typography 
                    variant="h3" 
                    sx={{ 
                      color: 'white',
                      fontWeight: 900
                    }}
                  >
                    {index + 1}
                  </Typography>
                </Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    mb: 3,
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    fontSize: { xs: '1.3rem', md: '1.5rem' }
                  }}
                >
                  {step.title}
                </Typography>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.8,
                    fontSize: '1.1rem'
                  }}
                >
                  {step.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Success Stories */}
      <Box sx={{ py: 15, bgcolor: theme.palette.background.default }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4 } }}>
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: theme.palette.primary.main,
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
                display: 'block'
              }}
            >
              Success Stories
            </Typography>
            <Typography 
              variant="h2" 
              sx={{ 
                fontWeight: 800,
                color: theme.palette.primary.main,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                mb: 3
              }}
            >
              Real Love Stories
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: theme.palette.text.secondary,
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Discover how our platform has helped thousands of couples find their happily ever after.
            </Typography>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            gap: 4,
            overflowX: { xs: 'auto', md: 'visible' },
            pb: { xs: 2, md: 0 },
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme.palette.primary.main,
              borderRadius: '4px',
            },
          }}>
            {successStories.map((story, index) => (
              <Card 
                key={index}
                sx={{ 
                  p: 5,
                  minWidth: { xs: '300px', md: 'auto' },
                  flex: { md: 1 },
                  height: '100%',
                  transition: 'all 0.4s ease',
                  borderRadius: '24px',
                  background: theme.palette.background.paper,
                  border: `1px solid rgba(62,2,23,0.1)`,
                  '&:hover': {
                    transform: 'translateY(-15px)',
                    boxShadow: '0 20px 40px rgba(62,2,23,0.15)',
                    border: `1px solid rgba(62,2,23,0.2)`
                  }
                }}
              >
                <Box sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  mb: 4
                }}>
                  <Avatar 
                    src={story.image} 
                    sx={{ 
                      width: 120,
                      height: 120,
                      mr: 3,
                      border: `4px solid ${theme.palette.primary.main}`,
                      boxShadow: '0 8px 25px rgba(62,2,23,0.2)'
                    }}
                  />
                  <Box>
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        fontSize: '1.2rem',
                        mb: 1
                      }}
                    >
                      {story.names}
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: theme.palette.text.secondary,
                        mb: 2,
                        fontWeight: 500
                      }}
                    >
                      Married {story.date}
                    </Typography>
                    <Box sx={{ display: 'flex' }}>
                      {[...Array(5)].map((_, i) => (
                        <StarIcon 
                          key={i} 
                          sx={{ 
                            color: '#FFD700',
                            fontSize: 24
                          }} 
                        />
                      ))}
                    </Box>
                  </Box>
                </Box>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.8,
                    fontSize: '1.1rem',
                    fontStyle: 'italic'
                  }}
                >
                  "{story.story}"
                </Typography>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Call to Action */}
      <Box sx={{ 
        position: 'relative',
        py: 15,
        overflow: 'hidden',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`
      }}>
        <Box
          component="img"
          src={weddingImages[0]}
          alt="Background"
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.1
          }}
        />
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ 
            textAlign: 'center',
            color: 'white'
          }}>
            <Typography 
              variant="h2" 
              sx={{ 
                mb: 4,
                fontWeight: 900,
                color: 'white',
                fontSize: { xs: '2.5rem', md: '3.5rem' }
              }}
            >
              Ready to Find Your
              <Box component="span" sx={{ 
                display: 'block',
                background: 'linear-gradient(45deg, #ffffff, #f0f0f0)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Perfect Match?
              </Box>
            </Typography>
            <Typography 
              variant="h5" 
              sx={{ 
                mb: 8,
                opacity: 0.9,
                fontWeight: 400,
                color: 'rgba(255,255,255,0.9)',
                lineHeight: 1.6,
                maxWidth: '600px',
                mx: 'auto'
              }}
            >
              Join thousands of singles who found their soulmate through our platform. 
              Your love story begins today.
            </Typography>
            {/* <Button
              component={Link}
              to="/register"
              variant="contained"
              size="large"
              startIcon={<CelebrationIcon />}
              endIcon={<ArrowForwardIcon />}
              sx={{
                bgcolor: 'white',
                color: theme.palette.primary.main,
                px: 8,
                py: 3,
                fontSize: '1.3rem',
                fontWeight: 700,
                borderRadius: '50px',
                boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
                '&:hover': { 
                  bgcolor: '#f5f5f5',
                  transform: 'translateY(-5px)',
                  boxShadow: '0 20px 45px rgba(0,0,0,0.3)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Start Your Love Story
            </Button> */}
          </Box>
        </Container>
      </Box>



      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>
    </Box>
  );
};

const features = [
  {
    icon: <SecurityIcon sx={{ fontSize: 50, color: '#3e0217' }} />,
    title: "Verified Profiles",
    description: "Every profile undergoes thorough verification to ensure authenticity and build trust within our community."
  },
  {
    icon: <SearchIcon sx={{ fontSize: 50, color: '#3e0217' }} />,
    title: "Smart Matching",
    description: "Our advanced AI algorithm analyzes compatibility factors to find your perfect match with precision."
  },
  {
    icon: <VerifiedUserIcon sx={{ fontSize: 50, color: '#3e0217' }} />,
    title: "Privacy First",
    description: "Your privacy and security are our top priorities with encrypted data and confidential matching."
  }
];

const stats = [
  { value: '2M+', label: 'Active Users' },
  { value: '100K+', label: 'Successful Matches' },
  { value: '98%', label: 'Success Rate' },
  { value: '24/7', label: 'Support' }
];

const steps = [
  {
    title: 'Create Your Profile',
    description: 'Sign up and build your detailed profile with photos, interests, and relationship preferences.'
  },
  {
    title: 'Discover Matches',
    description: 'Browse through compatible profiles and discover potential matches based on your criteria.'
  },
  {
    title: 'Connect & Meet',
    description: 'Start meaningful conversations and plan your first meeting with your perfect match.'
  }
];

const successStories = [
  {
    names: "Priya & Rahul",
    date: "June 2023",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    story: "We found each other on this platform and instantly connected. Our first meeting felt like we had known each other for years! The matching algorithm was spot on."
  },
  {
    names: "Anjali & Vikram",
    date: "March 2023",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    story: "The matching algorithm was spot on! We share the same values and dreams. Thank you for bringing us together and making our love story possible."
  },
  {
    names: "Meera & Arjun",
    date: "January 2023",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    story: "From the first message to our wedding day, everything felt right. We're grateful for this platform that made our dreams come true."
  }
];

export default Home;